// extracted by mini-css-extract-plugin
export default {"linkList":"cp_j5","editModule":"cp_j6"};